import { styled } from "@mui/material/styles";
import {
    FormControl, InputLabel, MenuItem, Select,
} from "@mui/material";
import React from "react";

const StyledFormControl = styled(FormControl, {
    shouldForwardProp: (prop) => !["fullHeight", "onClick", "value", "label", "neededWidth"].includes(prop),
})(({
    theme, onClick, value, label, neededWidth,
}) => ({
    "& .Mui-disabled fieldset": {
        backgroundColor: theme.palette.action.disabledBackground,
    },
    "& .Mui-disabled": {
        color: `${theme.palette.text.primary}!important`,
        WebkitTextFillColor: "initial",
    },
    "& .MuiOutlinedInput-root": {
        background: "none",
        fontSize: 12,
        margin: 0,
        padding: 0,
        "& .Mui-disabled": {
            cursor: (onClick && value) && "pointer",
            color: (onClick && value) && "#4594AD",
            textDecoration: (onClick && value) && "underline",
            "&:hover": {
                color: (onClick && value) && "inherit",
            },
        },
        "& .MuiOutlinedInput-notchedOutline": {
            "&  legend": {
                border: "none",
            },
            top: 0,
            height: 24,
            ...label && {
                marginTop: 12,
            },
        },
        "& .MuiOutlinedInput-input": {
            paddingTop: 4,
            paddingBottom: 2,
            paddingLeft: 3,
            paddingRight: 3,
            ...label && {
                marginTop: 13,
            },
        },
        "& .MuiIconButton-root": {
            minWidth: 16,
            marginRight: 4,
        },
        ...label ? {
            marginTop: 2,
            "& .MuiSelect-iconOutlined": {
                marginTop: 7,
            },
        } : {
            "& .MuiSelect-iconOutlined": {
                marginTop: "1px!important",
            },
            "&>*:not(.MuiOutlinedInput-notchedOutline):not(.MuiSelect-select)": {
                marginTop: 2,
            },
            "& .MuiSelect-select": {
                marginTop: 0.75,
            },
        },
    },
    "& .MuiInputLabel-shrink": {
        fontSize: 12,
        transform: "translate(2px, -7px) scale(1) !important",
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
        display: "none",
    },
    "& .MuiSelect-select": {
        paddingRight: "10px!important",
        ...neededWidth && {
            paddingRight: "20px!important",
        },
    },
    "& .MuiSelect-icon": {
        marginRight: -4,
    },
    ...label ? {
        height: 36,
    } : {
        height: 24,
    },
    ...neededWidth && {
        display: "table",
    },
}));
const getOption = (row, optionsFormat, optionsName) => {
    if (optionsFormat) {
        return optionsFormat(row);
    }
    if (optionsName) {
        return row[optionsName];
    }
    return row;
};
const CustomSelect = React.memo((props) => {
    const {
        fullWidth,
        neededWidth,
        className,
        disabled,
        required,
        label,
        defaultValue,
        value,
        onChange,
        onBlur,
        options,
        optionsKey,
        optionsValueType,
        optionsName,
        optionsFormat,
        placeholder,
        children,
        sx,
        inputRef,
        error,
        filterDisabled,
        filterData,
        filterOptions,
        onClick,
        maxHeight,
        menuItemStyle,
    } = props;

    return (
        <StyledFormControl
            variant="outlined"
            fullWidth={fullWidth}
            disabled={disabled}
            required={required}
            sx={sx}
            error={error}
            onClick={onClick}
            value={value}
            label={label}
            neededWidth={neededWidth}
        >
            {label ? (
                <InputLabel>
                    {label}
                </InputLabel>
            ) : null}
            <Select
                {...disabled && { IconComponent: "" }}
                className={className}
                defaultValue={defaultValue}
                value={value}
                onChange={onChange}
                onClose={onBlur}
                inputRef={inputRef}
                displayEmpty={!required}
                renderValue={value !== "" ? undefined : () => <span style={{ color: "#aaa" }}>{placeholder}</span>}
                {...maxHeight && { MenuProps: { PaperProps: { sx: { maxHeight } } } }}
                onClick={() => (onClick && value) && onClick(value)}
            >
                {options ? options.filter((row) => !filterOptions || (filterOptions && filterOptions(row))).map((row) => (
                    <MenuItem
                        key={row[optionsKey]}
                        style={menuItemStyle}
                        disabled={filterDisabled ? filterDisabled(row, filterData) : false}
                        value={optionsValueType === "key" ? row[optionsKey] : row}
                    >
                        {getOption(row, optionsFormat, optionsName)}
                    </MenuItem>
                )) : children}
            </Select>
        </StyledFormControl>
    );
});

export default CustomSelect;
